import debounce from 'lodash/debounce';
import ResizeObserver from 'resize-observer-polyfill';
import ImgBanner from '../ImgBanner/index.vue';
import { numStringToNum } from '../../helpers/typeConverter';
import breakpoints from '../../config/breakpoints';

const defaultTextFontSize = 0;
const mobileTextSizeAdjuster = 2.5;
const buttonSizeAdjuster = 3;

export default {
  name: 'PcLifeStyle',
  data() {
    return {
      className: 'app__life-style',
      ref: 'lifeStyle',
      textFontSize: defaultTextFontSize,
      resizeObserver: null,
    };
  },
  components: {
    ImgBanner,
  },
  props: {
    bgImage: {
      type: String,
      default: '',
    },
    mobileBgImage: {
      type: String,
      default: '',
    },
    imgAlt: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    textAlign: {
      type: String,
      default: 'left',
    },
    mobileTextAlign: {
      type: String,
      default: 'left',
    },
    mobileTextPosition: {
      type: String,
      default: 'bottom',
    },
    mobileTextSize: {
      type: [String, Number],
      default: '3',
    },
    textSize: {
      type: [String, Number],
      default: '3',
    },
    link: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
    theme: {
      type: String,
      default: 'dark',
    },
  },
  computed: {
    themeClassName() {
      return `${this.className}--${this.theme}`;
    },
    imgConClassName() {
      return `${this.className}__img-con`;
    },
    textClassName() {
      return `${this.className}__text`;
    },
    textConClassName() {
      return `${this.textClassName}__con`;
    },
    buttonTextClassName() {
      return `${this.textClassName}__button`;
    },
    textAlignClassName() {
      return `${this.textConClassName}--${this.textAlign}`;
    },
    mobileTextAlignClassName() {
      return `${this.textConClassName}__mobile--${this.mobileTextAlign}`;
    },
    mobileTextPositionClassName() {
      return `${this.textConClassName}__mobile--${this.mobileTextPosition}`;
    },
    hasText() {
      return !!this.text.length;
    },
    hasLink() {
      return !!this.link.length;
    },
    hasButtonText() {
      return !!this.buttonText.length;
    },
    containerEl() {
      return this.hasLink ? 'a' : 'div';
    },
    linkTitle() {
      return this.hasLink ? this.text : '';
    },
    linkUrl() {
      return this.hasLink ? this.link : '';
    },
    textStyles() {
      return this.textFontSize ? {
        fontSize: `${this.textFontSize}rem`,
      } : {};
    },
    textButtonStyles() {
      return this.textFontSize ? {
        fontSize: `${this.textFontSize / buttonSizeAdjuster}rem`,
      } : {};
    },
    lifeStyleEl() {
      return this.$refs[this.ref];
    },
  },
  methods: {
    onResize() {
      this.setTextFontSize();
    },
    setTextFontSize() {
      const { sm } = breakpoints;
      const ratio = window.innerWidth < sm
        /*
          mulitpling by mobileTextSizeAdjuster converts the mobile text size number
          to a number that is closer to the desktop text size number,
          avoiding a large difference between the mobile and desktop text size number
        */
        ? numStringToNum(this.mobileTextSize) * mobileTextSizeAdjuster
        : numStringToNum(this.textSize);
      this.textFontSize = this.lifeStyleEl.offsetWidth * (ratio * 0.001);
    },
    setResizeListener() {
      this.resizeObserver = new ResizeObserver(
        debounce(this.onResize, 250, { maxWait: 1000 }),
      ).observe(this.lifeStyleEl);
    },
    removeResizeListener() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    },
  },
  mounted() {
    this.setTextFontSize();
    this.setResizeListener();
  },
  beforeDestroy() {
    this.removeResizeListener();
  },
};
